import React, { useState, useEffect, useCallback, Fragment } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import useModal from 'app/hooks/useModal';
import useUtils from 'app/hooks/useUtils';
import { Svg, Modal } from 'app/components';
import ModalLegendContent from './ModalLegendContent';
import { LegendList, LegendListItem } from '../styles';

const propTypes = {
  legendData: PropTypes.arrayOf(PropTypes.object).isRequired
};

const iconsAmountMap = {
  xl: 3,
  md: 3,
  sm: 2,
  xs: 1
};

const SeatPlanLegend = ({ legendData }) => {
  const [t] = useTranslation();
  const { buildContentStaticUrl, getWindowWidth } = useUtils();
  const [iconsAmountToShow, setIconsAmount] = useState();
  const [isModal, showModal, hideModal] = useModal('seatPlanLegend');
  const [legendToPrint, setLegendData] = useState(
    legendData.slice(0, iconsAmountMap[getWindowWidth()])
  );

  const recalculateIconsAmount = useCallback(() => {
    const value = iconsAmountMap[getWindowWidth()];

    if (value !== iconsAmountToShow) {
      setIconsAmount(value);
      setLegendData(legendData.slice(0, iconsAmountMap[getWindowWidth()]));
    }
    // eslint-disable-next-line
  }, [iconsAmountToShow, legendData]);

  useEffect(() => {
    window.addEventListener('resize', recalculateIconsAmount);

    return () => window.removeEventListener('resize', recalculateIconsAmount);
  }, [recalculateIconsAmount]);

  return (
    <Fragment>
      <LegendList>
        <LegendListItem title={t('purchase.occupied')}>
          <div className="l-legend__inner">
            <img
              src={buildContentStaticUrl('/static/area_categories/occupied.svg')}
              className="l-legend__icon-single"
              alt=""
            />
            <p className="l-legend__text">{t('purchase.occupied')}</p>
          </div>
        </LegendListItem>

        <LegendListItem title={t('purchase.chosen')}>
          <div className="l-legend__inner">
            <img
              src={buildContentStaticUrl('/static/area_categories/choosen.svg')}
              className="l-legend__icon-single"
              alt=""
            />
            <p className="l-legend__text">{t('purchase.chosen')}</p>
          </div>
        </LegendListItem>

        {legendToPrint.map(item => (
          <LegendListItem key={item.displayName} title={item.description}>
            <div className="l-legend__inner">
              <img src={buildContentStaticUrl(item.image)} className="l-legend__icon" alt="" />
              <p className="l-legend__text">{item.displayName}</p>
            </div>
          </LegendListItem>
        ))}

        <LegendListItem>
          <button
            type="button"
            className="l-legend__inner _btn"
            title={t('common.show_more')}
            onClick={showModal}
          >
            <Svg id="more" />
            <p className="l-legend__text">{t('common.details')}</p>
          </button>
        </LegendListItem>
      </LegendList>

      <Modal
        isOpen={isModal}
        close={hideModal}
        title={t('purchase.modals.legend.header')}
        isMiddleWidth
      >
        <ModalLegendContent data={legendData} />
      </Modal>
    </Fragment>
  );
};

SeatPlanLegend.propTypes = propTypes;
export default SeatPlanLegend;
